import React from "react";
import ToastContext from "../../context/toastContext";

export const ToastConsumer = ({ children }) => (
  <ToastContext.Consumer>{context => children(context)}</ToastContext.Consumer>
);

export const withToastManager = Comp => props => (
  <ToastConsumer>
    {context => <Comp toastManager={context} {...props} />}
  </ToastConsumer>
);
